import script from "./PositionTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./PositionTab.vue?vue&type=script&lang=ts&setup=true"

import "./PositionTab.vue?vue&type=style&index=0&id=104b0ac8&lang=scss"

const __exports__ = script;

export default __exports__